<template>
  <div>
    <v-dialog v-model="questionamentoDialog" scrollable max-width="700">
      <base-modal>
        <h2 class="title">Questionamento</h2>
        <v-layout row wrap>
          <v-flex xs12>
            <v-textarea
              no-resize
              class="jns-input"
              v-model="observacao"
              placeholder=" "
              label="Observação"
            ></v-textarea>
          </v-flex>

          <v-flex xs4 offset-xs8 pt-0>
            <button class="button jns-button yellow-button" @click="enviar()">
              Enviar
            </button>
          </v-flex>
        </v-layout>
      </base-modal>
    </v-dialog>
    <v-dialog v-model="questionamentoSucessoDialog" :max-width="'640'">
      <base-modal>
        <h2 class="headline">Questionamento realizado com sucesso!</h2>
        <v-layout row wrap>
          <v-flex sm12 md4 offset-md8 pb-0 mt-4>
            <v-btn class="button jns-button yellow-button" @click="$router.go()"
              >OK</v-btn
            >
          </v-flex>
        </v-layout>
      </base-modal>
    </v-dialog>
  </div>
</template>

<script lang="js">
export default {
  name: "QuestionamentoComponent",
  data() {
    return {
      observacao: "",
      showTooTip: false,
      dados: [],
    };
  },
  props: {
    questionamentoDialog: {
      type: Boolean,
      default: false,
    },
    questionamentoSucessoDialog: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    enviar() {
      this.$emit("send", this.observacao);
    },
  },
  watch: {
    questionamentoDialog: function (value) {
      if (!value) this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
label {
  height: 42px;
  display: inline-block;
}
#jns {
  .msg__container {
    width: 30%;
    background-color: #fff;
    position: absolute;
    z-index: 999;
    box-shadow: 0 0 1em #ccc;
    padding: 12px;
    right: 30px;
    top: 0px;

    p {
      text-align: left;
      margin-bottom: 0;
      font-weight: normal;

      &.info-red {
        margin-bottom: 5px;
      }
    }
  }

  .info-red {
    color: #d21a5e;
  }

  .custom-i {
    font-size: 18px;
    cursor: pointer;
  }

  .box_group {
    border-radius: 10px;
    border: 1px solid;
    padding: 10px;
    border-color: lightgray;
    margin: 0px;
    margin-bottom: 10px;
  }

  .tooltip_icon {
    cursor: help;
  }
  .document_name {
    max-width: 315px;
    height: 50px;
    padding-left: 8px;
    margin-bottom: 10px;
  }
  .pad {
    margin-top: -22px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/QuestionamentoComponent.vue